import React from 'react';
import { useSelector } from 'react-redux';
import Logo from '@wix/da-ds/pkg/Logo';
import { useTranslation } from 'react-i18next';
import { Url, URLS } from '@wix/da-url';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiData } from '@wix/da-bi/pkg/events';
import Burger from '../_partials/Burger';
import SearchIconButton from './_partials/SearchIconButton';
import SubmitButton from './_partials/SubmitDropdown';
import UserMenuButton from './_partials/UserMenuButton';
import { getBackgroundVariant } from '../../DeviationBackground/redux/helpers';
import NotesButtonAndDropdown from '../_partials/NotesButtonAndDropdown';
import NotificationsDropdownWrapper from '../_partials/NotificationsDropdownWrapper';
import { getTheme, getThemeSkin } from '../../publicSession/selectors';
import s from './SiteHeaderMobile.scss';
const SiteHeaderMobile = ({ showNetworkBar, isLoggedIn, isUserDropdownOpen, closeNotificationsDropdown })=>{
    const { t } = useTranslation();
    const themeVariant = useSelector((state)=>getBackgroundVariant(getTheme(state), getThemeSkin(state)));
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['left-zone']
    }, /*#__PURE__*/ React.createElement(Burger, {
        showNetworkBar: showNetworkBar,
        iconClassName: s['icon']
    }), /*#__PURE__*/ React.createElement(BiLink, {
        biData: BiData({
            evid: 700,
            link_url: Url.buildFromPath(URLS.ROOT),
            link_name: 'logo'
        }),
        href: Url.buildFromPath(URLS.ROOT),
        "aria-label": t('siteHeader.a11y.home'),
        className: s['logo-link']
    }, /*#__PURE__*/ React.createElement(Logo, {
        size: "tiny",
        withText: false,
        themeVariant: themeVariant,
        allowCustomization: true
    })), isLoggedIn && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(NotificationsDropdownWrapper, {
        iconClassName: s['icon'],
        numberClassName: s['number']
    }), /*#__PURE__*/ React.createElement(NotesButtonAndDropdown, {
        iconButtonClassName: s['icon'],
        numberClassName: s['number']
    })), /*#__PURE__*/ React.createElement(SearchIconButton, {
        className: s['icon']
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['right-zone']
    }, /*#__PURE__*/ React.createElement(UserMenuButton, {
        hideNotificationCount: true
    }), /*#__PURE__*/ React.createElement(SubmitButton, {
        className: s['submit-button'],
        menuClassName: s['submit-menu']
    })));
};
SiteHeaderMobile.displayName = 'SiteHeaderMobile';
export default SiteHeaderMobile;

//# sourceMappingURL=SiteHeaderMobile.js.map